<template>
  <v-toolbar
    app
    flat
  >
    <v-toolbar-side-icon
      class="hidden-md-and-up"
      @click="toggleDrawer"
    />
    <v-container
      mx-auto
      py-0
    >
      <v-layout>
        <v-img
          :src="require('@/assets/logo.png')"
          class="mr-5"
          contain
          height="48"
          width="48"
          max-width="48"
          :to="{name: 'GuestHome'}"
          @click="$vuetify.goTo(0)"
        />
        <v-btn
          v-for="(link, i) in links"
          :key="i"
          class="ml-0 hidden-sm-and-down"
          flat
          @click="goToElement(link)"
        >
          {{ link.text }}
        </v-btn>
        <v-spacer/>
        <v-btn
          :to="{ name: 'SignIn' }"
          class="ml-0 hidden-sm-and-down"
          flat
        >
          Login
        </v-btn>
      </v-layout>
    </v-container>
  </v-toolbar>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: 'GuestToolbar',
    data: () => ({
      links: [
        {to: '#welcome', text: 'Home'},
      ],
    }),
    methods: {
      toggleDrawer() {
        this.sidebar = !this.sidebar;
      },
      goToElement(element) {
        if (this.$router.currentRoute.name === 'GuestHome') {
          this.$vuetify.goTo(element.to);
        } else {
          this.$router.push({name: 'GuestHome', hash: element.to});
        }
      },
    },
    computed: {
      ...mapGetters({
        isAdmin: 'guest/auth/isAdmin',
      }),
      sidebar: {
        get() {
          return this.$store.getters['common/ui/sidebar'];
        },
        set(value) {
          this.$store.dispatch('common/ui/setSidebar', value);
        },
      },
    },
  };
</script>

<style scoped>

</style>
